<template>
  <section class="wrapper_type_2">
    <SuspendedModal
      :statusInfo="statusInfo"
      :branch="false"
      :industry="false"
    ></SuspendedModal>
    <WarningModal
      :statusInfo="statusInfo"
      :branch="false"
      :industry="false"
    ></WarningModal>
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand
        href="#"
        class="hamburger_container"
        :style="[
          statusInfo.status && statusInfo.status == 1
            ? { marginRight: '50px !important' }
            : null,
        ]"
      >
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>
      </b-navbar-brand>
      <div
        v-if="company"
        style="margin: 0 auto; margin-left: 100px; margin-right: 50px"
        class="m-hide"
      >
        <p class="text-center display-flex branchName" style="margin-bottom: 0">
          <span class="" style="font-size: 25px">{{
            company ? company.name : ""
          }}</span>
          <star-rating
            class="ml-2"
            v-model="companyRating"
            :show-rating="true"
            :read-only="true"
            :star-size="starSize"
            :fixed-points="2"
            :round-start-rating="false"
          ></star-rating>
        </p>
      </div>

      <div style="margin: 0 auto; margin-right: 10%" class="m-hide"></div>

      <b-collapse id="nav-collapse" is-nav>
        <!-- <h4 class="mr-5">{{company ? company.name : ''}} </h4> -->

        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 1"
          class="payment_due_text"
        >
          <span class="text-black">
            {{ $t("text.cMasterLayout.SubExpire") }} </span
          ><span class="payment_due_date">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span
          >{{ $t("text.cMasterLayout.makePayment") }}
        </b-nav-item>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 2"
          class="payment_due_text"
        >
          {{ $t("text.cMasterLayout.subHasExpired") }}
        </b-nav-item>

        <!-- <select @change="changeCountry" style="width: 280px !important">
            <option value="">select country</option>
            <option value="FR">France</option>
            <option value="NG">Nigeria</option>
            <option value="KE">Kenya</option>
          </select> -->

        <b-navbar-nav class="ml-auto">
          <div>
            <select
              @change="changeLanguage"
              v-model="usedLang"
              class="w-100 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
            >
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select>
            <!-- <select
              @change="changeLanguage"
              class="w-lg-100 mb-3 mb-md-3 mb-lg-0 mr-3"
            >
              <option disabled value="">
                {{ $t("text.cMasterLayout.selectLanguage") }}
              </option>
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select> -->
          </div>

          <b-nav-item
            href="#"
            class="bell_noti"
            style="position: relative"
            v-if="statusInfo.status && statusInfo.status !== 0"
            @click="showNotification"
          >
            <img src="@/assets/img/notification.svg" width="28" />
          </b-nav-item>

          <b-nav-item href="#">
            <img
              :src="
                company && company.url
                  ? company.url
                  : require('@/assets/img/avatar.svg')
              "
              height="30px"
            />
          </b-nav-item>
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'companyProfile' }">{{
                $t("text.cMasterLayout.profile")
              }}</router-link></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
      id="ccvv"
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="mt-3 text-right m-hide-icon">
        <img
          src="@/assets/img/close_btn.png"
          width="35px"
          height="35px"
          @click="toggleCollapsibleNavBar"
          id="mySidenav"
        />
      </div>
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>

        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="20" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <li
            v-if="userDetails.email !== 'demonstration@gmail.com'"
            class="list-group-item"
            :class="
              activeRoute === 'companyDashboard' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'companyDashboard',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/dashboard (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>

          <!-- UPDATE PRICE -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'price_management' ||
              activeRoute === 'branch_cluster' ||
              activeRoute === 'approve_price'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              (userInfo.roles.includes('CompanyPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Update Price')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'price_management',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.stationManagement.updatePrice") }}
              </span>
            </router-link>
          </li>

          <!-- NEW UPDATE PRICE -->
          <!-- <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'price_management' ||
              activeRoute === 'price_managers' ||
              activeRoute === 'branch_cluster' ||
              activeRoute === 'approve_price'
                ? 'navbar_item_active'
                : ''
            "
            v-show="
              (userInfo.roles.includes('CompanyPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Update Price')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/money-transfer.svg" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.priceManagement") }}
              </span>
              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
 
                <li>
                  <router-link
                    :to="{
                      name: 'price_management',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'fund_wallet_request'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.stationManagement.updatePrice") }}
                  </router-link>
                </li>

                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'price_managers' ? 'navbar_item_active' : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'price_managers',
                      query: {
                        entityType: 'Company',
                        companyId: this.$route.query.companyId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.priceManager.title") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li> -->

          <!-- PRICE CHANGE LOG-->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'price_management_log' ? 'navbar_item_active' : ''
            "
            v-if="
              userInfo.roles.includes('Price Log') &&
              userDetails.email !== 'demonstration@gmail.com'
            "
          >
            <router-link
              :to="{
                name: 'price_management_log',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.omit.priceChangeLog") }}
              </span>
            </router-link>
          </li>

          <!-- PUMP CALIBRATION -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              (userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              (userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Pump calibration')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          > -->
            <router-link
              :to="{
                name: 'pump_calibration_logs',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/measure.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.pumpsCalibration.title") }}
              </span>
            </router-link>
          </li>

          <!-- SPECIFIC SALES REPORT FOR DEMO BRANCH -->
          <li
            class="list-group-item"
            :class="activeRoute === 'companySales' ? 'navbar_item_active' : ''"
            v-show="userDetails.email == 'supportest@gmail.com'"
          >
            <router-link
              :to="{
                name: 'companySales',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                    }
                  : { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/profit-report (1).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cDashboard.salesReport") }}
              </span>
            </router-link>
          </li>

          <!-- REPORTS -->
          <li
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('CompanyReport') &&
                comPlanFeatures.includes('Report')) ||
                (userInfo.roles.includes('Company') &&
                  comPlanFeatures.includes('Report')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'companySales' ||
              activeRoute === 'company_variance_report' ||
              activeRoute === 'BranchSalesTransactions' ||
              activeRoute === 'tanks_filled' ||
              activeRoute === 'tanks_filled' ||
              activeRoute === 'company_branch_sales' ||
              activeRoute === 'company_tank_stock' ||
              activeRoute === 'company_cash_flow' ||
              activeRoute === 'products_filled' ||
              activeRoute === 'products_received' ||
              activeRoute === 'company-sufficiency' ||
              activeRoute === 'CompanyEsales' ||
              activeRoute === 'companyRetainershipSales' ||
              activeRoute === 'CompanyBranchesReport'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/profit-report (1).svg" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.report") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <!-- report submenu here -->
                <!-- SALES REPORT -->
                <li class="treeview-men">
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.cDashboard.salesReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'companySales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'companySales'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cusMasterLayout.stationSales") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'company_variance_report',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company_variance_report'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cusMasterLayout.pumpVariance") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'companyTankVariance',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company_variance_report'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.tankVariance") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'CompanyEsales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'CompanyEsales'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.omit.remisSales") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'companyRetainershipSales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'companyRetainershipSales'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.endOfDayReport.retainershipSales") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- CASH REPORT -->
                <li class="treeview-men">
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.cDashboard.cashReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'company_cash_flow',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company_cash_flow'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.cashflow") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'company_branch_sales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company_branch_sales'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.companySalesSummary") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'DailyBranchTrans',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === ' CompanyBranchesReport'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.dailyBranchTransactions") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- INVENTORY REPORT -->
                <li class="treeview-men">
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.bMasterLayout.inventoryReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'company_tank_stock',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company_tank_stock'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cDashboard.tanK") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'products_filled',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'products_filled'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.productsDischarged") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'company-product-valuation',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company-product-valuation'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.stockValuation") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'products_received',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'products_received'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.productsReceived") }}
                        </router-link>
                      </li>
                      <!-- SUFFICIENCY METRIC -->
                      <li
                        v-if="
                          userInfo.roles.includes('ManageOutlet') ||
                          userInfo.roles.includes('ViewOutlet') ||
                          userInfo.roles.includes('SupportAdmin') ||
                          userInfo.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'company-sufficiency',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'company-sufficiency'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cMasterLayout.sufficiencyMetrics") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'companySales',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companySales' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.stationSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'company_variance_report',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_variance_report'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cusMasterLayout.pumpVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'companyTankVariance',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_variance_report'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.tankVariance") }}
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'tanks_filled',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'tanks_filled' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.tanksFilled") }}
                  </router-link>
                </li> -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'company_cash_flow',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_cash_flow'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.cashflow") }}
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'company_tank_stock',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_tank_stock'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cDashboard.tanK") }}
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'company_branch_sales',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_branch_sales'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.companySalesSummary") }}
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'products_filled',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'products_filled'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.productsDischarged") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'products_received',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'products_received'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.stockValuation") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'company-product-valuation',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' company-product-valuation'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.productsReceived") }}
                  </router-link>
                </li> -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'DailyBranchTrans',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' CompanyBranchesReport'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.dailyBranchTransactions") }}
                  </router-link>
                </li> -->
                <li>
                  <router-link
                    :to="{
                      name: 'CompanyBranchesReport',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === ' CompanyBranchesReport'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.sendBranchReport") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- DRY STOCK -->
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'non-wet-product-Sales' ||
              activeRoute === 'NonWetProducts' ||
              activeRoute === 'NonWetProductsCategories' ||
              activeRoute === 'NonWetProductSupply' ||
              activeRoute === 'non-wet-product-Sales' ||
              activeRoute === 'BranchProductStock'
                ? 'navbar_item_active'
                : null
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((comPlanFeatures.includes('Dry stock') &&
                userInfo.roles.includes('canManageNonWetProducts')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/box.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.dryStock") }}
              </span>
              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'NonWetProducts',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'fund_wallet_request'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.products") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'NonWetProductSupply',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.supplies") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'non-wet-product-Sales',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.sales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'BranchProductStock',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_loyalty'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.branchProduct") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'NonWetProductsCategories',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_loyalty'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.category") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- MANUAL RECORDS -->
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'CompanyServices' ||
              activeRoute === 'CompanyBranchSpace' ||
              activeRoute === 'CompanyLease'
                ? 'navbar_item_active'
                : null
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              (comPlanFeatures.includes('Manual records') ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/folder.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.manualRecords") }}
              </span>
              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'CompanyServices',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'fund_wallet_request'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.services") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'CompanyLease',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.branchLease") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'companyBranchSpace',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyBranchSpace'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.availableSpaces") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- RETAIL OUTLETS -->
          <li
            class="list-group-item"
            :class="activeRoute === 'our_branches' ? 'navbar_item_active' : ''"
            v-if="
              (userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              (userInfo.roles.includes('ViewOutlet') &&
                comPlanFeatures.includes('Retail Outlets')) ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'our_branches',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/fuel-station (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.retailOutlets") }}
              </span>
            </router-link>
          </li>

          <!-- DEALERS -->
          <li
            class="list-group-item"
            :class="activeRoute === 'our_dealers' ? 'navbar_item_active' : ''"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Dealer management')) ||
                (userInfo.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Dealer management')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'our_dealers',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/team(1).png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.dealers") }}
              </span>
            </router-link>
          </li>

          <!-- GROUP MANAGEMENT -->

          <li
            class="list-group-item"
            :class="activeRoute === 'CompanyGroup' ? 'navbar_item_active' : ''"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('GroupManager') &&
                comPlanFeatures.includes('Group management')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'CompanyGroup',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/deal.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.groupManagement") }}
              </span>
            </router-link>
          </li>

          <!-- REGION -->

          <li
            class="list-group-item"
            :class="activeRoute === 'CompanyRegion' ? 'navbar_item_active' : ''"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('GroupManager') &&
                comPlanFeatures.includes('Region management')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'CompanyRegion',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/tour (1).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.zones") }}
              </span>
            </router-link>
          </li>

          <!-- SUFFICIENCY METRICS -->

          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'company-sufficiency' ? 'navbar_item_active' : ''
            "
            v-if="
              userInfo.roles.includes('ManageOutlet') ||
              userInfo.roles.includes('ViewOutlet') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'company-sufficiency',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: $route.query.companyId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-1"
                ><svg
                  width="35"
                  height="35"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 0C10.751 0 0 10.751 0 24C0 37.249 10.751 48 24 48C37.249 48 48 37.249 48 24C48 10.751 37.249 0 24 0ZM24 1C36.708 1 47 11.292 47 24C47 36.709 36.708 47 24 47C11.292 47 1 36.709 1 24C1 11.292 11.292 1 24 1ZM24.5 12C24.3674 12 24.2402 12.0527 24.1464 12.1464C24.0527 12.2402 24 12.3674 24 12.5V14H23.5C23.3674 14 23.2402 14.0527 23.1464 14.1464C23.0527 14.2402 23 14.3674 23 14.5V16H21V13.506C21 13.3734 20.9473 13.2462 20.8536 13.1524C20.7598 13.0587 20.6326 13.006 20.5 13.006C20.3674 13.006 20.2402 13.0587 20.1464 13.1524C20.0527 13.2462 20 13.3734 20 13.506V16H15V16.025C11.642 16.285 9.033 19.323 9.033 23C9.033 25.541 10.283 27.773 12.16 29H8.506C8.3718 29 8.2431 29.0533 8.1482 29.1482C8.05331 29.2431 8 29.3718 8 29.506V31.496C8 31.776 8.226 32.002 8.506 32.002H11.187L12.049 33.725C12.0907 33.8078 12.1546 33.8773 12.2335 33.9259C12.3125 33.9744 12.4033 34.0001 12.496 34H13.046C13.1634 34.5635 13.4709 35.0694 13.9169 35.4332C14.363 35.7969 14.9205 35.9963 15.496 35.998C16.0717 35.9959 16.6293 35.796 17.0753 35.432C17.5213 35.0679 17.8287 34.5616 17.946 33.998H18.496C18.5887 33.9981 18.6796 33.9724 18.7585 33.9239C18.8374 33.8753 18.9013 33.8058 18.943 33.723L19.805 32H28.195L29.057 33.723C29.0987 33.8058 29.1626 33.8753 29.2415 33.9239C29.3204 33.9724 29.4113 33.9981 29.504 33.998H30.057C30.174 34.5617 30.4811 35.068 30.927 35.4321C31.3729 35.7962 31.9303 35.996 32.506 35.998C33.0818 35.9962 33.6395 35.7966 34.0856 35.4324C34.5317 35.0683 34.839 34.5618 34.956 33.998H35.504C35.5967 33.9981 35.6875 33.9724 35.7665 33.9239C35.8454 33.8753 35.9093 33.8058 35.951 33.723L36.812 32H39.494C39.774 32 40 31.774 40 31.494V29.02H39.494V29H35.84C37.718 27.773 38.967 25.541 38.967 23C38.967 19.154 36.116 16 32.535 16H29V14.5C29 14.3674 28.9473 14.2402 28.8536 14.1464C28.7598 14.0527 28.6326 14 28.5 14H28V12.5C28 12.3674 27.9473 12.2402 27.8536 12.1464C27.7598 12.0527 27.6326 12 27.5 12H24.5ZM25 13H27V14H25V13ZM24 15H28V16H24V15ZM16 17H17V29H16V17ZM18 17H30V29H18V17ZM31 17H32V29H31V17ZM15 17.025V28.975C12.224 28.717 10.033 26.18 10.033 23C10.033 19.82 12.224 17.283 15 17.025ZM33 17.025C35.776 17.283 37.967 19.82 37.967 23C37.967 26.18 35.776 28.717 33 28.975V17.025ZM9.012 30.012H38.988V30.99H9.012V30.012ZM12.307 32.002H13.507C13.287 32.294 13.123 32.629 13.047 33H12.807L12.307 32.002ZM15.477 32.002H15.516C16.341 32.013 16.996 32.672 16.996 33.5C16.996 34.334 16.33 35 15.496 35C14.662 35 13.996 34.334 13.996 33.5C13.996 32.672 14.652 32.012 15.476 32.002H15.477ZM17.484 32.002H18.687L18.187 33H17.945C17.8684 32.6371 17.7112 32.296 17.485 32.002H17.484ZM29.312 32.002H30.518C30.297 32.294 30.132 32.629 30.057 33H29.813L29.312 32.002ZM32.486 32.002H32.526C33.35 32.013 34.006 32.672 34.006 33.5C34.006 34.334 33.34 35 32.506 35C31.672 35 31.006 34.334 31.006 33.5C31.006 32.672 31.661 32.012 32.486 32.002ZM34.494 32.002H35.694L35.194 33H34.955C34.8784 32.6371 34.7202 32.296 34.494 32.002ZM15.496 33C15.3634 33 15.2362 33.0527 15.1424 33.1464C15.0487 33.2402 14.996 33.3674 14.996 33.5C14.996 33.6326 15.0487 33.7598 15.1424 33.8536C15.2362 33.9473 15.3634 34 15.496 34C15.6286 34 15.7558 33.9473 15.8496 33.8536C15.9433 33.7598 15.996 33.6326 15.996 33.5C15.996 33.3674 15.9433 33.2402 15.8496 33.1464C15.7558 33.0527 15.6286 33 15.496 33ZM32.506 33C32.3734 33 32.2462 33.0527 32.1524 33.1464C32.0587 33.2402 32.006 33.3674 32.006 33.5C32.006 33.6326 32.0587 33.7598 32.1524 33.8536C32.2462 33.9473 32.3734 34 32.506 34C32.6386 34 32.7658 33.9473 32.8596 33.8536C32.9533 33.7598 33.006 33.6326 33.006 33.5C33.006 33.3674 32.9533 33.2402 32.8596 33.1464C32.7658 33.0527 32.6386 33 32.506 33Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.sufficiencyMetrics") }}</span
              >
            </router-link>
          </li> -->

          <!-- BANK -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('SetupBank') &&
                comPlanFeatures.includes('Bank')) ||
                (userInfo.roles.includes('ViewBankDeposit') &&
                  comPlanFeatures.includes('Bank')) ||
                (userInfo.roles.includes('ManageTerminals') &&
                  comPlanFeatures.includes('Bank')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'company_accounts' ||
              activeRoute === 'link-company-bank' ||
              activeRoute === 'bank-linked-transactions' ||
              activeRoute === 'live-bank-transactions' ||
              activeRoute === 'company_POS' ||
              activeRoute === 'company-pos-terminals' ||
              activeRoute === 'bank-account-request' ||
              activeRoute === 'set-recurring-invoice'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/wallet (6).svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.bank") }}</span
              >

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userInfo.roles.includes('SetupBank') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'bank-account-request',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'bank-account-request'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankAcctRequest") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('SetupBank') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'link-company-bank',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'link-company-bank'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankAccounts") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankDeposit') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'bank-linked-transactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'link-company-bank'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankDeposit") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankLog') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'bank-transactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'link-company-bank'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.bankTrans") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ManageTerminals') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'company-pos-terminals',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company-pos-terminals'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.posTerminals") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankDeposit') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'company_POS',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_POS' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.posReport") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userInfo.roles.includes('SetupBank') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'set-recurring-invoice',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'set-recurring-invoice'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.recurringPayment") }}
                  </router-link>
                </li>
                <!-- <li
                  v-if="
                    userInfo.roles.includes('SetupBank') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'subscription-transactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'set-recurring-invoice'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.subscriptionTransactions") }}
                  </router-link>
                </li> -->
              </ul>
            </div>
          </li>

          <!-- Users -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('ManageUsers') &&
                comPlanFeatures.includes('Manage users')) ||
                // (userInfo.roles.includes('Company') &&
                //   comPlanFeatures.includes('Manage users')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'company_users' ? 'navbar_item_active' : null
            "
          >
            <router-link
              :to="{
                name: 'company_users',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                    }
                  : { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
              :class="
                activeRoute === 'company_users' ? 'navbar_item_active' : ''
              "
            >
              <span class="mr-2 icon">
                <img src="@/assets/img/users-group.png" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.manageUsers") }}</span
              >
            </router-link>
          </li>

          <!-- MANAGEMENT -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('ViewExpense') &&
                comPlanFeatures.includes('Management')) ||
                (userInfo.roles.includes('ManageExpense') &&
                  comPlanFeatures.includes('Management')) ||
                (userInfo.roles.includes('ManageZones') &&
                  comPlanFeatures.includes('Management')) ||
                (userInfo.roles.includes('ManagePayments') &&
                  comPlanFeatures.includes('Management')) ||
                (userInfo.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Management')) ||
                (userInfo.roles.includes('ViewBankLog') &&
                  comPlanFeatures.includes('Management')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'manage_expenses' ||
              activeRoute === 'expenses_categories' ||
              activeRoute === 'zones' ||
              activeRoute === 'RoleManagement' ||
              activeRoute === 'MapRoles' ||
              activeRoute === 'company_outstanding_payments' ||
              activeRoute === 'price_managers' ||
              activeRoute === 'alerts_and_alarm' ||
              activeRoute === 'assets'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/briefcase.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.management") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userInfo.roles.includes('ViewExpense') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'company_expenses',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_expenses'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.expenses") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userInfo.roles.includes('ViewExpense') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'transaction_count',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'transaction_count'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.transactionSalesCount") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userInfo.roles.includes('ViewExpense') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'companyTransactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyTransactions'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.branchWalletTransactions") }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    v-if="
                      userInfo.roles.includes('ManageExpense') ||
                      userInfo.roles.includes('Company') ||
                      userInfo.roles.includes('SupportAdmin') ||
                      userInfo.roles.includes('PartnerAdmin')
                    "
                    :to="{
                      name: 'expenses_categories',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'expenses_categories'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.categories") }}
                  </router-link>
                </li>

                <!-- ZONES -->
                <li
                  v-show="
                    userInfo.roles.includes('ManageZones') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'zones',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="activeRoute === 'zones' ? 'navbar_item_active' : ''"
                  >
                    {{ $t("text.cMasterLayout.regions") }}
                  </router-link>
                </li>

                <!-- Manage roles -->
                <li
                  v-show="
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'RoleManagement',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'RoleManagement'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.omit.manageSubcat") }}
                  </router-link>
                </li>
                <li v-if="userInfo.roles.includes('ManagePayments')">
                  <router-link
                    :to="{
                      name: 'company_outstanding_payments',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_outstanding_payments'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.outstandingPayments") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ManageOutlet') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                  class="list-group-item"
                  :class="activeRoute === 'assets' ? 'navbar_item_active' : ''"
                >
                  <router-link
                    :to="{
                      name: 'assets',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.assetGroup") }}
                    </span>
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('ViewBankLog') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                  class="list-group-item"
                  :class="
                    activeRoute === 'companyWallet' ? 'navbar_item_active' : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'companyWallet',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title"
                      >{{ $t("text.cMasterLayout.companyWallet") }}
                    </span>
                  </router-link>
                </li>
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'shutdownHistory'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'shutdownHistory',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.shutdownPumps") }}
                    </span>
                  </router-link>
                </li>

                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'AggregatedFaults'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'AggregatedFaults',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.aggregatedCompanyFault") }}
                    </span>
                  </router-link>
                </li>
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'MaintenanceList'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'MaintenanceList',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.maintenance") }}</span
                    >
                  </router-link>
                </li>

                <!-- WAYBILL -->
                <li
                  class="list-group-item"
                  :class="activeRoute === 'Waybill' ? 'navbar_item_active' : ''"
                >
                  <router-link
                    :to="{
                      name: 'Waybill',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">{{
                      $t("text.cMasterLayout.waybill")
                    }}</span>
                  </router-link>
                </li>

                <!-- TRUCK AND DRIVERS -->
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'TrucksAndDrivers'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'TrucksAndDrivers',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.trucksDrivers") }}</span
                    >
                  </router-link>
                </li>

                <!-- ALERT AND ALARMS -->
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'alerts_and_alarm'
                      ? 'navbar_item_active'
                      : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'alerts_and_alarm',
                      query: { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.cMasterLayout.alertsAlarms") }}</span
                    >
                  </router-link>
                </li>

                <!-- APPROVALS -->
                <li
                  class="list-group-item"
                  :class="
                    activeRoute === 'price_managers' ? 'navbar_item_active' : ''
                  "
                >
                  <router-link
                    :to="{
                      name: 'price_managers',
                      query: {
                        entityType: 'Company',
                        companyId: this.$route.query.companyId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.priceManager.title") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- Remis -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('ManageRetainers') &&
                comPlanFeatures.includes('Retainership')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'remisRetainership' ||
              activeRoute === 'card-request' ||
              activeRoute === 'retainer-details'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/svg/remislogo.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.fundWallet.remis") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'remisRetainership',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'remisRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.retainership") }}
                  </router-link>
                </li>

                <!-- new route  -->
                <li class="treeview-men">
                  <a href="#" class="vue_router_link has-submenu">
                    {{ $t("text.cards.cards") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'all-cards',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'companySales'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.cards.allCards") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'card-request',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                }
                              : { companyId: this.$route.query.companyId },
                          }"
                          class="vue_router_link"
                          :class="
                            activeRoute === 'card-request'
                              ? 'navbar_item_active'
                              : ''
                          "
                        >
                          {{ $t("text.retainership.cardRequest") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!--  -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'card-request',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'card-request' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.retainership.cardRequest") }}
                  </router-link>
                </li> -->
                <!-- hidden -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'fund_wallet_request',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'fund_wallet_request'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.walletFundRequest") }}
                  </router-link>
                </li> -->

                <li>
                  <router-link
                    :to="{
                      name: 'company_loyalty',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_loyalty'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.loyalty") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- MANAGE PEDDLING -->
          <li
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Manage peddling')) ||
                (userInfo.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Manage peddling')) ||
                (userInfo.roles.includes('Company') &&
                  comPlanFeatures.includes('Manage peddling')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'manage_orders' ||
              activeRoute === 'company_products' ||
              activeRoute === 'manage_drivers' ||
              activeRoute === 'manage_trucks'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/Golden_Bricks.svg" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.managePeddling") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'manage_orders',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'manage_orders'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.orders") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'company_products',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_products'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.products") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'manage_drivers',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'manage_drivers'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.drivers") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- WALLET -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'company_wallet' ? 'navbar_item_active' : ''
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              (comPlanFeatures.includes('Wallet') ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'company_wallet',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/img/wallet.png" width="30px" />
              </span>
              <span class="sidenav_list_title"
                >{{ $t("text.cMasterLayout.wallet") }}
              </span>
            </router-link>
          </li>

          <!-- INVOICE -->
          <li
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              userDetails.email !== 'demonstration@gmail.com' &&
              ((userInfo.roles.includes('Company') &&
                comPlanFeatures.includes('Invoices')) ||
                userInfo.roles.includes('SupportAdmin') ||
                userInfo.roles.includes('PartnerAdmin'))
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'company_invoice' ||
              activeRoute === 'subscription-transactions'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/invoice (4).svg" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.invoices") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'company_invoice',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'company_invoice'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.invoices") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userInfo.roles.includes('SetupBank') ||
                    userInfo.roles.includes('Company') ||
                    userInfo.roles.includes('SupportAdmin') ||
                    userInfo.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'subscription-transactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                          }
                        : { companyId: this.$route.query.companyId },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'subscription-transactions'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.cMasterLayout.subscriptionTransactions") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'company_invoice' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'company_invoice',
                query: { companyId: this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/img/invoice (4).svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.invoices") }}
              </span>
            </router-link>
          </li> -->
          <!-- SUPPORT -->
          <li
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
            class="list-group-item"
            :class="
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/svg/support.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.cMasterLayout.supportAdmin") }}
              </span>
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="100px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="100px"
                  height="40px"
                />
              </div>
            </div>
          </div>
          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <span class="mr-2"
              ><i
                class="mr-3 fa fa-sign-out"
                style="font-size: 20px; color: white"
              ></i
            ></span>
            <span class="sidenav_list_title">
              {{ $t("text.cMasterLayout.logOut") }}
            </span>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import configObject from "@/config";
import countryProducts from "@/products";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
import StarRating from "vue-star-rating";

export default {
  name: "MasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    StarRating,
  },
  data() {
    return {
      statusInfo: {},
      LogoUrl,
      isViewOnly: false,
      masterbackgroundUrl,
      company: {},
      companyIcon: null,
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      showStationManagementDropDown: false,
      showOurCorporateCustomersDropDown: false,
      showManageExpensesDropDown: false,
      showReportDropDown: false,
      showPeddlingManagementDropDown: false,
      supportedCompany: null,
      companyRating: 0,
      starSize: 20,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      PriceApproval: JSON.parse(localStorage.getItem("PriceApproval")),
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    userName: {
      get() {
        if (localStorage.getItem("userDetails")) {
          return this.userDetails.firstName + "  " + this.userDetails.lastName;
        } else {
          return "Username";
        }
      },
      set(value) {},
    },
  },

  created() {
    if (
      (!this.userInfo.roles.includes("SupportAdmin") &&
        !this.userInfo.roles.includes("PartnerAdmin")) ||
      this.userInfo.roles.includes("Company")
    ) {
      this.getCompany();
    }
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    // console.log(this.$store.getters.getLanguage);
    // console.log(this.windowLoc);
    // if (this.windowLoc == "localhost") {
    //   document.getElementById("ccvv").style.backgroundColor = "white";
    // }
    if (
      this.userDetails.roles.includes("SupportAdmin") ||
      this.userDetails.roles.includes("PartnerAdmin")
    ) {
      this.support = true;
      this.companyId = this.$route.query.companyId;
      let ml = sessionStorage.getItem(this.companyId);
      if (!ml) {
        let allData = localStorage.getItem("companiesList");
        let dt = JSON.parse(allData);
        dt.forEach((my, index) => {
          if (my.id === this.companyId) {
            ml = JSON.stringify(my);
            sessionStorage.setItem(this.companyId, ml);
          }
        });
      }

      this.company = JSON.parse(ml);
      this.$eventHub.$emit("company", this.company);
    }
    this.checkViewOnly();
    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
    $(".treeview-men > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        // console.log("closed treeview men");
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        // console.log("added class to treeview men");
        $(".treeview-men").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  beforeMount() {
    this.activeRoute = this.$route.name;
  },
  methods: {
    showNotification() {
      const status = this.statusInfo.status;
      if (
        (status == 1 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showWarningModal();
      if (
        (status == 2 && !this.userInfo.roles.includes("SupportAdmin")) ||
        userInfo.roles.includes("PartnerAdmin")
      )
        this.showSuspendedModal();
    },
    getCompanyRating() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          if (typeof res.data.averageRateValue === "number") {
            this.companyRating = res.data.averageRateValue;
          }
        })
        .catch((e) => {});
    },
    checkStatus() {
      // this.showSuspendedModal();
      const modalShown = this.$store.getters.getModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getStatusInfo;
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (
              (this.$route.name !== "company_invoice" &&
                this.$route.name !== "invoice_details" &&
                this.$route.name !== "invoice_payments" &&
                this.$route.name !== "make_payment" &&
                !this.userInfo.roles.includes("SupportAdmin")) ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showWarningModal();
              this.$store.commit("setModalShown", true);
            }
          }
          if (response.data.status == 2) {
            if (
              (this.$route.name !== "company_invoice" &&
                this.$route.name !== "invoice_details" &&
                this.$route.name !== "invoice_payments" &&
                this.$route.name !== "make_payment" &&
                !this.userInfo.roles.includes("SupportAdmin")) ||
              userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    changeCountry(e) {
      // console.log(e.target.value);
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      // console.log(locale);
      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value])
      );

      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      //   console.log(e.target.value);
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      // console.log(locale);
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    checkViewOnly() {
      this.isViewOnly = this.$store.getters.getViewOnly;
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout")
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    getCompany() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyCompanies`,
          configObject.authConfig()
        )
        .then((response) => {
          this.company = response.data[0];

          // Logic for subscription plan feature
          let subPlanFeat;
          let isSubPlanFeat;
          subPlanFeat = response.data[0].planFeatures;

          isSubPlanFeat = localStorage.getItem("subPlanFeatures");
          if (!isSubPlanFeat) {
            localStorage.setItem(
              "subPlanFeatures",
              JSON.stringify(subPlanFeat)
            );
            this.comPlanFeatures = JSON.parse(
              localStorage.getItem("subPlanFeatures")
            );
          }
          const PriceApproval = response.data[0].priceApproval;
          localStorage.setItem("PriceApproval", JSON.stringify(PriceApproval));
          // this.comPlanFeatures = response.data[0].planFeatures;
          // console.log(this.comPlanFeatures);
          // Logic for subscription plan feature ended

          this.$eventHub.$emit("company", response.data[0]);

          this.checkStatus();
          this.getCompanyRating();
        })
        .catch((error) => {});
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));
      const treeviewz = Array.from(document.querySelectorAll(".treeview-men"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title")
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
        treeviewz.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
        treeviewz.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));
      const treeviewz = Array.from(document.querySelectorAll(".treeview-men"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
        treeviewz.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },
    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
};
</script>
